import * as React from "react";
import { Button, Modal, Typography, Stack, Box, useMediaQuery } from "@mui/material";
import DisabledInputBox from "../../shared/DisabledCardIput";
import InputBox from "../../shared/InputBox";
import CloseModalIcon from "../../icons/RoundCloseIcon.svg";
import CardCircuit from "../../icons/cardCircuit.png";
import InactiveElpse from "../../icons/welcomeInactiveElipse.png";
import VisaLogo from "../../icons/visa-logo.png";
import MasterCardLogo from "../../icons/masterCardIcon.png";
import { useDispatch, useSelector } from "react-redux";
import { getUpdateBankCard, getDeleteBankCard, selectPaymentState, getPaymentMethods, clearBankAndCardStates } from "../../resui/payments/sagas/residentpaymentsSlice";
import { makeStyles } from "@mui/styles";
import CircularProgress from "@mui/material/CircularProgress";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import SpinnerModal from "../../shared/Modal/SpinnerModal";
import { approvedISOStandards } from "../util/approvedISOStandards";
import { setDeleteBankCardRequest, setUpdateBankCardRequest, DEFAULT_ADHOC_CARD_UUID } from "../../pmui/residents/saga/pmResidentsSlice";
import Amex from "../../icons/AMEX.svg";
import Discover from "../../icons/Discover.svg";

const useStyles = makeStyles((theme) => ({
  globalError: {
    display: "flex",
    flexDirection: "row",
    marginBottom: "30px",
    borderTop: "2px  solid #DB3939",
    borderRadius: "24px",
    padding: "12px 20px",
    width: "100%",
  },
  wrapper: {
    margin: "1px",
    position: "relative",
  },
  buttonProgress: {
    color: "#053742",
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  background: "#FFFFFF",
  boxShadow: "0px 0px 40px rgba(0, 0, 0, 0.1)",
  p: 4,
};

export default function UpdateCardPaymentModal(props: any) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const isOnMobileScreen = useMediaQuery("(max-width:600px)");
  const matches380 = useMediaQuery("(max-width:380px)");
  const [isEdit, setIsEdit] = React.useState(true);
  const [nickName, setNickName] = React.useState(props.cardOwner);
  const [names, setNames] = React.useState(props.names);
  const [expirationDate, setExpirationDate] = React.useState(props.expiration);
  const [address, setAddress] = React.useState(props.address);
  const [city, setCity] = React.useState(props.city);
  const [state, setState] = React.useState(props.state);
  const [zip, setZip] = React.useState(props.zip);
  const [country, setCountry] = React.useState(props.country);

  //validation errors state
  const [cardGlobalError, setCardGlobalError] = React.useState<string | null>(null);
  const [cardNameError, setCardNameError] = React.useState("");
  const [cardExpirationError, setCardExpirationError] = React.useState("");
  const [cardAddressError, setCardAddressError] = React.useState("");
  const [cardZipError, setCardZipError] = React.useState("");
  const [cardCityError, setCardCityError] = React.useState("");
  const [disableCardSubmit, setDisableCardSubmit] = React.useState(true);
  const { isFetching, isCardSuccess, isError, cardErrorMessage, isCardDeleted } = useSelector(selectPaymentState);

  const setExpirationDateHandler = (expiration: any) => {
    setExpirationDate(expiration);
    if (expiration.length === 2 && !expiration.includes("/")) {
      setExpirationDate([expiration.slice(0, 2), "/", expiration.slice(2)].join(""));
    }
  };
  const [isSpinnerModalOpen, setIsSpinnerModalOpen] = React.useState(false);
  const [spinnerStatus, setSpinnerStatus] = React.useState<string | null>(null);

  const handleEdit = () => {
    setIsEdit(false);
  };
  const validateCardNames = () => {
    if (names.length === 0) {
      setCardNameError("Card name is empty!");
      return false;
    } else {
      setCardNameError("");
      return true;
    }
  };
  const validateCardExpiration = () => {
    if (expirationDate.length === 0) {
      setCardExpirationError("Card expiration date is empty!");
      return false;
    } else {
      setCardExpirationError("");
      return true;
    }
  };
  const validateCardAddress = () => {
    if (address.length === 0) {
      setCardAddressError("Card address is empty!");
      return false;
    } else {
      setCardAddressError("");
      return true;
    }
  };
  const validateCardZip = () => {
    if (zip.length === 0) {
      setCardZipError("Card ZIP code is empty!");
      return false;
    } else {
      setCardZipError("");
      return true;
    }
  };

  const validateCardCity = () => {
    if (city.length === 0) {
      setCardCityError("Card city is empty!");
      return false;
    } else {
      setCardCityError("");
      return true;
    }
  };

  const { Countries: approvedCountries, States: approvedStates, Provinces: approvedProvinces } = approvedISOStandards;

  const disableCardBtn = () => {
    if (names.length === 0 || expirationDate.length === 0 || address.length === 0 || country.length === 0 || city.length === 0 || state.length === 0 || zip.length === 0) {
      setDisableCardSubmit(true);
    } else {
      setDisableCardSubmit(false);
    }
  };
  const handleCloseSpinnerModal = React.useCallback(() => {
    setIsSpinnerModalOpen(false);
    dispatch(getPaymentMethods());
  }, [dispatch, getPaymentMethods]);

  React.useEffect(() => {
    if (isCardSuccess || isCardDeleted) {
      setSpinnerStatus("stop");
    }
    if (isError) {
      setIsSpinnerModalOpen(false);
      setCardGlobalError(cardErrorMessage);
    }
  }, [isCardSuccess, isCardDeleted, isError, handleCloseSpinnerModal, cardErrorMessage, props]);

  React.useEffect(() => {
    setCardGlobalError(null);
    return () => {
      setCardGlobalError(null);
    };
  }, []);

  React.useEffect(() => {
    if (names.length === 0 || expirationDate.length === 0 || address.length === 0 || country.length === 0 || city.length === 0 || state.length === 0 || zip.length === 0) {
      setDisableCardSubmit(true);
    } else {
      setDisableCardSubmit(false);
    }
  }, [names, expirationDate, address, country, city, state, zip]);

  const updateBankCard = () => {
    const fullNames = names.split(" ");
    dispatch({
      type: clearBankAndCardStates.type,
    });

    if (validateCardNames() && validateCardExpiration() && validateCardAddress() && validateCardCity() && validateCardZip()) {
      props.uuid !== DEFAULT_ADHOC_CARD_UUID && setIsSpinnerModalOpen(true);
      dispatch({
        type: props.uuid === DEFAULT_ADHOC_CARD_UUID ? setUpdateBankCardRequest.type : getUpdateBankCard.type,
        payload: {
          ExpirationDate: expirationDate.replace(/[/]/g, ""),
          CardholderFirstname: fullNames[0],
          CardholderLastname: fullNames[1],
          NickName: nickName,
          BillingAddress: {
            City: city,
            State: state,
            Zip: zip,
            Line1: address,
            Line2: "",
            Country: country,
          },
        },
        bankcardUuid: props.uuid === DEFAULT_ADHOC_CARD_UUID ? undefined : props.uuid,
      });

      props.uuid === DEFAULT_ADHOC_CARD_UUID && props.handleClose && props.handleClose();
    }
  };

  const deleteBankCardHandler = () => {
    props.uuid !== DEFAULT_ADHOC_CARD_UUID && setIsSpinnerModalOpen(true);
    dispatch({
      type: props.uuid === DEFAULT_ADHOC_CARD_UUID ? setDeleteBankCardRequest.type : getDeleteBankCard.type,
      bankcardUuid: props.uuid === DEFAULT_ADHOC_CARD_UUID ? undefined : props.uuid,
    });

    props.uuid === DEFAULT_ADHOC_CARD_UUID && props.handleClose && props.handleClose();
  };

  const restStateOnCloseHandler = () => {
    setAddress(props.address);
    setNames(props.names);
    setCity(props.city);
    setState(props.state);
    setZip(props.zip);
    setExpirationDate(props.expiration);
    setNickName(props.cardOwner);
    setCountry(props.country);
  };

  let bankCardImage = VisaLogo;
  switch (props.cardNetwork?.toLowerCase()) {
    case "visa":
      bankCardImage = VisaLogo;
      break;
      case "mastercard":
        bankCardImage = MasterCardLogo;
      break;
      case "amex":
      case "american express":
        bankCardImage = Amex;
        break;
        case "discover":
          bankCardImage = Discover;
          break;
          }

  return (
    <div>
      <Modal
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
            ...style,
            width: matches380 ? "100%": "472px",
            minHeight: matches380 ? "100%": "610px",
            borderRadius: matches380 ? "none": "24px",
          }}
        >
          <Stack direction="column" justifyContent="space-between" alignItems="space-between" spacing={2}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
              <div>
                <ArrowBackRoundedIcon
                  sx={{ color: "#39A2DB", height: 30, width: 30, cursor: "pointer" }}
                  onClick={() => {
                    props.handleClose();
                    restStateOnCloseHandler();
                  }}
                />
              </div>
              <div>
                <Typography id="payment-method-title">{props.cardType === "DB" ? "Debit" : "Credit"} Card</Typography>
              </div>
              <div>
                <img
                  src={CloseModalIcon}
                  alt="close"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    props.handleClose();
                    restStateOnCloseHandler();
                  }}
                />
              </div>
            </Stack>
            {cardGlobalError?.length ? (
              <div className={classes.globalError}>
                <Typography
                  style={{
                    fontFamily: "'Open Sans', sans-serif",
                    fontStyle: "normal",
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "18px",
                    color: "#DB3939",
                  }}
                >
                  {cardGlobalError}
                </Typography>
              </div>
            ) : (
              ""
            )}
            <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Stack
              direction="column"
              justifyContent="space-between"
              alignItems="space-between"
              spacing={2}
              style={{
                width: 320,
                borderRadius: "24px",
                background: "linear-gradient(to right,  rgba(162, 219, 250, 0.7) ,rgba(57, 162, 219, 0.7))",
                padding: "16px",
              }}
            >
              <Stack direction="row" justifyContent="space-between" alignItems="space-between" spacing={2}>
                <div>
                  <Typography
                    style={{
                      fontFamily: "'Open Sans', sans-serif",
                      fontStyle: "normal",
                      fontWeight: 600,
                      fontSize: "18px",
                      lineHeight: " 13px",
                      textTransform: "capitalize",
                      color: " #FFFFFF",
                    }}
                  >
                    {props.cardType === "DB" ? "Debit" : "Credit"} Card
                  </Typography>
                </div>
                <div>
                  <img
                    src={bankCardImage}
                    alt="card"
                    style={{
                      width: "30px",
                      height: "20px",
                    }}
                  />
                </div>
              </Stack>
              <Stack direction="row" justifyContent="space-between" alignItems="space-between" spacing={2}>
                <div>
                  {isEdit ? (
                    <Typography
                      style={{
                        fontFamily: "'Open Sans', sans-serif",
                        fontStyle: "normal",
                        fontWeight: 600,
                        fontSize: "14px",
                        lineHeight: " 13px",
                        textTransform: "capitalize",
                        color: " #FFFFFF",
                      }}
                    >
                      {props.cardOwner}
                    </Typography>
                  ) : (
                    <InputBox label="Nick Name" style={{ width: matches380 ? "150px" : "190px" }} placeholder="" value={nickName} onChange={(e: any) => setNickName(e.target.value)} />
                  )}
                </div>
                <div>
                  {isEdit ? (
                    <Typography
                      style={{
                        fontFamily: "'Open Sans', sans-serif",
                        fontStyle: "normal",
                        fontWeight: 600,
                        fontSize: "14px",
                        lineHeight: " 13px",
                        textTransform: "capitalize",
                        color: " #FFFFFF",
                      }}
                    >
                      ***
                    </Typography>
                  ) : (
                    <></>
                  )}
                </div>
              </Stack>
              <div>
                <img src={CardCircuit} alt="" />
              </div>
              <div>
                <Typography
                  style={{
                    fontFamily: "'Open Sans', sans-serif",
                    fontStyle: "normal",
                    fontWeight: 600,
                    fontSize: "14px",
                    lineHeight: " 13px",
                    textTransform: "capitalize",
                    color: " #FFFFFF",
                  }}
                >
                  <img src={InactiveElpse} alt="Inactive" />
                  <img src={InactiveElpse} alt="Inactive" />
                  <img src={InactiveElpse} alt="Inactive" />
                  <img src={InactiveElpse} alt="Inactive" /> {props.lastFour}
                </Typography>
              </div>
              <Stack direction="row" justifyContent="space-between" alignItems="space-between" spacing={2}>
                <div>
                  {isEdit ? (
                    <Typography
                      style={{
                        fontFamily: "'Open Sans', sans-serif",
                        fontStyle: "normal",
                        fontWeight: 600,
                        fontSize: "14px",
                        lineHeight: " 13px",
                        textTransform: "capitalize",
                        color: " #FFFFFF",
                      }}
                    >
                      {props.names}
                    </Typography>
                  ) : (
                    <InputBox label="Names on Card" style={{ width: matches380 ? "150px" : "190px" }} placeholder="" value={names} onChange={(e: any) => setNames(e.target.value)} onError={disableCardBtn} error={cardNameError} />
                  )}
                </div>
                <div>
                  {isEdit ? (
                    <Typography
                      style={{
                        fontFamily: "'Open Sans', sans-serif",
                        fontStyle: "normal",
                        fontWeight: 600,
                        fontSize: "14px",
                        lineHeight: " 13px",
                        textTransform: "capitalize",
                        color: " #FFFFFF",
                      }}
                    >
                      {props.expiration}
                    </Typography>
                  ) : (
                    <InputBox label="EXP" style={{ width: "80px" }} placeholder="MM/YYYY" value={expirationDate} onChange={(e: any) => setExpirationDateHandler(e.target.value)} onError={disableCardBtn} error={cardExpirationError} maxLength={7} />
                  )}
                </div>
              </Stack>
            </Stack>
            </div>

            <div>
              <DisabledInputBox
                label="Address"
                style={{
                  padding: "10px",
                  color: "#14142B",
                }}
                disabled={isEdit}
                value={address}
                onChange={(e: any) => setAddress(e.target.value)}
                onError={disableCardBtn}
                error={cardAddressError}
              />
            </div>
            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2} style={{ marginBottom: "15px" }}>
              <div>
                <DisabledInputBox
                  label="City"
                  disabled={isEdit}
                  style={{
                    padding: "10px",
                  }}
                  value={city}
                  onChange={(e: any) => setCity(e.target.value)}
                  onError={disableCardBtn}
                  error={cardCityError}
                />
              </div>
              <div>
                <select
                  placeholder="State"
                  disabled={isEdit}
                  style={{
                    border: "1px solid #F1F0F5",
                    borderRadius: "24px",
                    height: "36px",
                    width: "100%",
                    padding: "0 15px",
                    fontFamily: "'Open Sans', sans-serif",
                  }}
                  defaultValue={state}
                  onChange={(e) => setState(e.target.value)}
                >
                  <option style={{ height: "36px" }} value=''>
                    {`Select State`}
                  </option>
                  {country === "US" ? (
                    approvedStates.map((stateRecord) => (
                      <option style={{ height: "36px" }} key={stateRecord.Code} value={stateRecord.Code}>
                        {stateRecord.State + " - " + stateRecord.Code}
                      </option>
                    ))
                  ) : country === "CA" ? (
                    approvedProvinces.map((provinceRecord) => (
                      <option style={{ height: "36px" }} key={provinceRecord.Code} value={provinceRecord.Code}>
                        {provinceRecord.Province + " - " + provinceRecord.Code}
                      </option>
                    ))
                  ) : (
                    <option style={{ height: "36px" }} value="NA">
                      other
                    </option>
                  )}
                </select>
              </div>
            </Stack>
            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2} style={{ marginBottom: "15px" }}>
              <div>
                <DisabledInputBox
                  label="ZIP"
                  disabled={isEdit}
                  style={{
                    width: "95%",
                    padding: "10px",
                  }}
                  value={zip}
                  onChange={(e: any) => setZip(e.target.value)}
                  onError={disableCardBtn}
                  error={cardZipError}
                />
              </div>

              <select
                placeholder="Country"
                disabled={isEdit}
                style={{
                  border: "1px solid #F1F0F5",
                  borderRadius: "24px",
                  height: "36px",
                  width: "50%",
                  padding: "0 15px",
                  fontFamily: "'Open Sans', sans-serif",
                }}
                defaultValue={country}
                onChange={(e) => {
                  setCountry(e.target.value);
                  setState('');
                }}
              >
                {approvedCountries.map((countryRecord) => (
                  <option style={{ height: "36px" }} key={countryRecord.Code} value={countryRecord.Code}>
                    {" "}
                    {countryRecord.Country + " - " + countryRecord.Code}
                  </option>
                ))}
              </select>
            </Stack>
            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2} style={{ marginBottom: "15px" }}>
              <div className={classes.wrapper}>
                {isEdit ? (
                  <React.Fragment>
                    <Button id="delete-payment" onClick={deleteBankCardHandler} color="error">
                      Delete
                    </Button>{" "}
                    {isFetching ? (
                      <CircularProgress
                        size={26}
                        sx={{
                          color: "#39A2DB",
                        }}
                        className={classes.buttonProgress}
                      />
                    ) : (
                      <></>
                    )}
                  </React.Fragment>
                ) : (
                  <></>
                )}
              </div>
              <div className={classes.wrapper}>
                {isEdit ? (
                  <Button variant="contained" id="add-bank-btn" onClick={handleEdit}>
                    Edit Card
                  </Button>
                ) : (
                  <React.Fragment>
                    <Button variant="contained" id="add-bank-btn" onClick={updateBankCard} disabled={disableCardSubmit || isFetching}>
                      Save
                    </Button>
                    {isFetching ? (
                      <CircularProgress
                        size={26}
                        sx={{
                          color: "#39A2DB",
                        }}
                        className={classes.buttonProgress}
                      />
                    ) : (
                      <></>
                    )}
                  </React.Fragment>
                )}
              </div>
            </Stack>
          </Stack>
        </Box>
      </Modal>
      {isSpinnerModalOpen ? <SpinnerModal isInvisible={true} width={"472px"} height={isOnMobileScreen ? "100%" :"610px"} openSpinnerModal={isSpinnerModalOpen} handleCloseSpinnerModal={handleCloseSpinnerModal} spinnerStatus={spinnerStatus} closeCancel={props.handleClose} /> : <></>}
    </div>
  );
}
